import React, { useState, useEffect } from "react";
import { Button, Container, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PropTypes from "prop-types";
import useMediaQuery from "@mui/material/useMediaQuery";
import fetchData from "../assets/data";
import { boilerMakes } from "../assets/data";
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import axios from "axios";
import Cookies from "js-cookie";
import { API_BASE_URL } from "../components/Config";
import { useNavigate } from "react-router-dom";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function FindOutMore() {
  const { id } = useParams();
  const [findMorcards, setFindMorCards] = useState([]);
  const [value, setValue] = useState(0);
  const [read, setRead] = useState(false);
  const [open, setOpen] = useState(false);
  const [axpended, setAxpended] = useState(false);
  const match1990 = useMediaQuery("(max-width:450px)");
  const checkWidth = window.innerWidth;
  const { enqueueSnackbar } = useSnackbar();
  const [firstName, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [postcode, setPostcode] = useState("");
  const [address, setAddress] = useState("");
  const [boiler, setBoiler] = useState("");
  const navigate = useNavigate();

  const simulateAPIRequest = async (url, method, data) => {
    try {
      const token = Cookies.get("token");
      const response = await axios({
        method,
        url,
        data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        enqueueSnackbar(error.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar("An error occurred", { variant: "error" });
      }
    }
  };

  const handleSubmit = async (e) => {
      e.preventDefault();

      const formData = new FormData(e.target);
      const data = Object.fromEntries(formData.entries());

      try {
        const response = await fetch(`${API_BASE_URL}/plans/create-checkout-session/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });

        const result = await response.json();

        if (result.url) {
          window.location.href = result.url; // 🔁 Redirect to Stripe Checkout
        } else {
          alert("Failed to redirect to payment.");
        }
      } catch (err) {
        console.error("Checkout error:", err);
        alert("An error occurred during checkout.");
      }
    };


  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleSurnameChange = (e) => {
    setSurname(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleDocumentDownload = async () => {
    try {
      const url = `${API_BASE_URL}/customer/document/`;
      const response = await axios({
        method: "GET",
        url,
        responseType: "blob",
      });

      const contentDisposition = response.headers["content-disposition"];
      let filename = "Terms&Conditions.pdf";

      if (
        contentDisposition &&
        contentDisposition.indexOf("attachment") !== -1
      ) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);

      link.click();

      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download document:", error);
      enqueueSnackbar("Failed to download document", { variant: "error" });
    }
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handlePostCodeChange = (e) => {
    setPostcode(e.target.value);
    console.log("PostCode changed");
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  const handleBoilerDetailsChange = (e) => {
    setBoiler(e.target.value);
  };

  const [csrfToken, setCsrfToken] = useState("");
  const [user_id, setUserId] = useState("");
  useEffect(() => {
    const fetchCsrfToken = async () => {
      const token = Cookies.get("token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      try {
        console.log("fetching HEADER", headers);
        const response = await axios.get(`${API_BASE_URL}/plans/get-csrf/`, {
          headers: headers,
        });
        setCsrfToken(response.data.csrfToken);
        setUserId(response.data.user_id);
      } catch (error) {}
    };
    console.log(axpended, "axpended");

    fetchCsrfToken();
  }, []);

  useEffect(() => {
    fetchData(id, setFindMorCards);
  }, [id]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handelCards = () => {
    setAxpended(!axpended);

    const cardElements = document.querySelectorAll(".cards_actions");

    console.log(axpended, "axpended");
    console.log(cardElements, "cardElements");

    cardElements.forEach((element) => {
      element.style.marginTop = axpended == true ? "0rem" : "7rem";
    });
  };

  useEffect(() => {
    if (checkWidth <= 450) {
      setAxpended(true);
    } else {
      setAxpended(false);
    }
  }, [checkWidth]);

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  return (
    <>
      <Container maxWidth="xl">
        <div className="main_div_find">
          <div className="box_one_find">
            <div className="check_stp1">
              <p>Step 1 of 2</p>
              <h1>Your Details</h1>
              <form
                className="form_dabits"
                // action={`${API_BASE_URL}/plans/create-checkout-session/`}
                // method="POST"
                onSubmit={handleSubmit}
              >
                <div>
                  <label htmlFor="1">First Name*</label>
                  <input
                    type="text"
                    id="1"
                    placeholder="First Name"
                    onChange={handleFirstNameChange}
                    name="first_name"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="2">Surname*</label>
                  <input
                    type="text"
                    placeholder="SurName"
                    required
                    id="2"
                    name="surname"
                    onChange={handleSurnameChange}
                  />
                </div>
                <div>
                  <label htmlFor="3">Email Address*</label>
                  <input
                    type="email"
                    placeholder="Email Address"
                    required
                    name="email"
                    id="3"
                    onChange={handleEmailChange}
                  />
                </div>
                <div>
                  <label htmlFor="4">Phone Number*</label>
                  <input
                    type="number"
                    placeholder="Phone Number"
                    required
                    name="phone_number"
                    id="4"
                    onChange={handlePhoneNumberChange}
                  />
                </div>
                <div className="btn_dabid_div">
                  <span className="span_dabid">
                    <label htmlFor="5">Post Code*</label>
                    <br />
                    <input
                      type="text"
                      placeholder="Post Code"
                      required
                      name="postcode"
                      id="4"
                      value={postcode}
                      onChange={handlePostCodeChange}
                    />
                  </span>
                </div>
                <div>
                  <label htmlFor="6">Enter Your Address Manually*</label>
                  <input
                    type="text"
                    placeholder="Enter Your Address"
                    required
                    name="address"
                    id="6"
                    value={address}
                    onChange={handleAddressChange}
                  />
                </div>

                <div className="boiler_details">
                  <h1>Boiler Details</h1>
                  <div className="debid_celaction">
                    <span className="span_dabid">
                      <label htmlFor="5">Make</label>
                      <br />
                      <select
                        className="celect_dabid form-select"
                        onChange={handleBoilerDetailsChange}
                        required
                      >
                        {boilerMakes.map((item, i) => (
                          <option key={i} value={item.value} required>
                            {item.value}
                          </option>
                        ))}
                      </select>
                    </span>
                    <input
                      type="hidden"
                      name="csrfmiddlewaretoken"
                      value={csrfToken}
                    />
                    <input type="hidden" name="user_id" value={user_id} />
                    <input type="hidden" name="plan_id" value={id} />
                    <Button
                      type="submit"
                      variant="contained"
                      className="paymint_btn anka_tag"
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div
            className="box_celected_plans"
            style={{ height: axpended ? "150px" : "auto" }}
          >
            {axpended ? (
              <button className="icons_expended" onClick={handelCards}>
                {" "}
                <ArrowBackIosRoundedIcon />
              </button>
            ) : null}
            {findMorcards.map((item, i) => {
              const parts = item.title.split("+");
              return (
                <div key={i}>
                  <div className="selected_plan_div">
                    <span>
                      <p>{item?.sel}</p>
                      <h1>
                        {parts[0]}
                        {parts.length > 1 && (
                          <span style={{ color: "#7ff1ea", marginLeft: "3px" }}>
                            +{parts[1]}
                          </span>
                        )}
                      </h1>
                      <p className="m-0">{item?.ser}</p>
                    </span>
                    <img src={item?.img} alt="icons" />
                  </div>
                  <div className="cards_actions">
                    <div className="cards_actions">
                      {item?.working.map((item, i) => (
                        <div className="working" key={i}>
                          <CheckCircleOutlineRoundedIcon className="iconmark" />
                          {item}
                        </div>
                      ))}
                    </div>
                    <div className="cards_actions">
                      {item?.notworking?.map((item, i) => (
                        <div className="notwarking" key={i}>
                          <CancelOutlinedIcon className="notwar" />
                          <span className="spanundesr">{item}</span>
                        </div>
                      ))}
                    </div>
                    <div className="view_div">
                      <p>
                        Review what is covered in your WeCare policy, and what
                        is not. <span onClick={handleOpen}>View here</span>
                      </p>
                      <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <div className="modal_find">
                          <div className="find_close">
                            <IconButton>
                              <CloseIcon onClick={handleClose} />
                            </IconButton>
                          </div>
                          <div>
                            <Tabs
                              value={value}
                              onChange={handleChange}
                              aria-label="basic ta bs example"
                              className="main_tabs"
                            >
                              <Tab
                                label="Covered"
                                {...a11yProps(0)}
                                className="tabeBtn"
                              />
                              <Tab
                                label="Not Covered"
                                {...a11yProps(1)}
                                className="tabeBtn"
                              />
                            </Tabs>
                          </div>
                          <div className="find_tabs">
                            <CustomTabPanel value={value} index={0}>
                              <div className="cards_actions">
                                {item?.working.map((item, i) => (
                                  <div className="working" key={i}>
                                    <CheckCircleOutlineRoundedIcon className="iconmark" />{" "}
                                    {item}
                                  </div>
                                ))}
                              </div>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={1}>
                              <div className="cards_actions">
                                {item?.notworking.map((item, i) => (
                                  <div className="notwarking" key={i}>
                                    <CancelOutlinedIcon className="notwar" />{" "}
                                    {item}
                                  </div>
                                ))}
                              </div>
                            </CustomTabPanel>
                          </div>
                          <div className="btnFounds">
                            <Button
                              variant="outlined"
                              onClick={handleDocumentDownload}
                            >
                              Download Terms & Conditions
                            </Button>
                          </div>
                        </div>
                      </Modal>
                    </div>
                  </div>
                  <div className="month_div">
                    <h1>{item.isFixedPrice ? "Total Price" : item?.month}</h1>
                    <span className="d-flex align-items-baseline">
                      <h2>{item?.price}</h2>
                      {item.isFixedPrice ? "" : "p/m"}
                    </span>
                  </div>
                  <p className="desc_dabid">
                    New boiler total price includes all parts and labour.{" "}
                    {read || (
                      <span className="read_btn" onClick={() => setRead(true)}>
                        Read More
                      </span>
                    )}
                  </p>
                  {read && (
                    <div className="read_more">
                      <p className="reading">
                        We will reach out to you well in advance of your
                        agreement renewal date. Your agreement is set to renew
                        automatically unless you opt to cancel. This automatic
                        renewal is designed to maintain continuous coverage for
                        you. If you prefer not to proceed with automatic
                        renewal, feel free to get in touch with us to opt out.{" "}
                        <span
                          className="read_btn"
                          onClick={() => setRead(false)}
                        >
                          Read Less
                        </span>
                      </p>
                    </div>
                  )}
                  {!item.isFixedPrice && (
                    <>
                      <div className="month_div">
                        <h1>{item?.serv}</h1>
                        <span className="d-flex align-items-baseline">
                          <h2>{item?.fee}</h2>
                        </span>
                      </div>
                      <p className="desc_dabid">{item.desc1}</p>
                    </>
                  )}
                </div>
              );
            })}
            <button className="icons_expended_bot" onClick={handelCards}>
              {" "}
              <ArrowBackIosRoundedIcon />
            </button>
          </div>
        </div>
      </Container>
    </>
  );
}

export default FindOutMore;
